export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/constant.js
// module id = 1204
// module chunks = 0